<div class="">
    <h1 class="fs-32 text-brightPurple mb-3">{{loaMessageTitle}}</h1>
    <p class="fs-16 text-secondary mb-3 mb-lg-4">
        {{loaMessageBody}}
    </p>

    <form [formGroup]="loaForm">
        <label for="" class="fs-14 text-bodyGrey fw400 mb-1 d-block">How do you provide Letter of Authority
            (LoA)?</label>
        <div class="radio-group mb-3">
            <div *ngIf="loaList.length" class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="inlineCheckbox1" [value]="1"
                    formControlName="generateType">
                <label class="form-check-label label-align" for="inlineCheckbox1">Select LoA</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="inlineCheckbox2" [value]="2"
                    formControlName="generateType">
                <label class="form-check-label label-align" for="inlineCheckbox2">Generate New</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="inlineCheckbox3" [value]="3"
                    formControlName="generateType">
                <label class="form-check-label label-align" for="inlineCheckbox3">Upload existing</label>
            </div>
        </div>

        <div class="mb-4" *ngIf="f1['generateType'].value == 1 && loaList.length">
            <label class="fs-14 text-bodyGrey fw400 mb-1"> Select LoA </label>
            <ng-select class="form-ngselect" [loading]="isLoaLoading" placeholder="Select LoA" [searchable]="false"
                [clearable]="false" formControlName="loaId">
                <ng-option *ngFor="let loa of loaList; let i = index" [value]="loa.loaId">
                    {{ loa.loaId + ' - ' + loa.authorisedEmailId + ' ('+ loa.loaStatus +')' }}
                </ng-option>
            </ng-select>
        </div>

        <div class="mb-4" *ngIf="f1['generateType'].value == 2">
            <p *ngIf="!userService.isLOAExist" class='mt-3 d-block fs-16'>You will receive an mail from
                <b>no-reply&#64;oneflow.com</b>
            </p>
            <p *ngIf="userService.isLOAAwaiting">
                Please sign the Letter of Authority (LoA) that was emailed to you. If you need us to resend the LoA,
                please click the button below
            </p>
        </div>

        <ng-container *ngIf="f1['generateType'].value == 3">
            <div class="mb-3">
                <div class="form-group">
                    <label class="form-label text-bodyGrey mb-1 fs-14 mb-1">Upload existing LoA ({{
                        LOAFileConfig.FileType.join(', ') }} only)</label>
                    <input type="file" class="form-control inputTyp1 mb-1" (change)="onFileChange($event)" />
                    <p class="text-danger fs-14 " *ngIf="fileError">{{ fileError }}</p>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label class="form-label text-bodyGrey mb-1 fs-14 mb-1">LoA validity period (in months)</label>
                    <ng-select class="form-ngselect" placeholder="Select expiry month" formControlName="expiry"
                        [searchable]="false" [clearable]="false" (change)="createExpiryDate($event)">
                        <ng-option *ngFor="let month of [].constructor(36); let i = index" [value]="i+1">
                            {{ i+1 }}
                        </ng-option>
                    </ng-select>
                    <p *ngIf="f1['expiry']?.touched && f1['expiry']?.errors?.['required']"
                        class="text-danger fs-14 mb-0">
                        Start date is required
                    </p>
                </div>
            </div>
        </ng-container>

        <div class="mb-4" *ngIf="f1['generateType'].value != 1 && !isLoaLoading">
            <div class="d-flex justify-content-between align-items-center">
                <label class="fs-14 text-bodyGrey fw400 mb-1"> Contact person </label>
                <div class="d-flex justify-content-md-end ps-1">
                    <button (click)="enableContactEdit()" class="GA-editContact btn btn-link btn-xs mb-1 text-brightPurple px-1 shadow-0">
                        {{ loaForm.get('contactEmail')?.disabled ? 'Edit' : 'Cancel' }}
                    </button>
                </div>
            </div>
            <ng-select class="form-ngselect" [loading]="isContactLoading" placeholder="Select contact"
                [searchable]="false" [clearable]="false" [readonly]="loaForm.get('contactEmail')?.disabled || false"
                formControlName="contactEmail" (change)="selectContact($event)">
                <ng-option *ngFor="let contact of contactList; let i = index" [value]="contact.email">
                    {{ contact.firstName + ' ' + contact.lastName + ( contact.email == 'addNewContact' ? '' : ' ('+
                    contact.email +')') }}
                </ng-option>
            </ng-select>
        </div>
    </form>
    <!-- <form *ngIf="!loaForm.get('contactEmail')?.disabled && f1['generateType'].value != 1 && !isLoaLoading" [formGroup]="contactDetailFormGroup">
        <div class="row">
            <div class="col-lg-6 mb-4">
                <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Title</label>
                <ng-select class="form-ngselect" placeholder="Select title" formControlName="title" [searchable]="false"
                    [clearable]="true">
                    <ng-option *ngFor="let item of listOfTitles" [value]="item">{{ item }}</ng-option>
                </ng-select>
                <p *ngIf="contactDetailFormGroup.get('title')?.touched && contactDetailFormGroup.get('title')?.errors"
                    class="text-danger fs-14 mt-1 mb-0">
                    <span *ngIf="contactDetailFormGroup.get('title')?.hasError('required')">Title is required</span>
                </p>
            </div>
            <div class="col-lg-6 mb-4">
                <label for="" class="fs-14 text-bodyGrey fw400 mb-1">First name</label>
                <input type="text" class="form-control inputTyp1" formControlName="firstName"
                    placeholder="Enter first name">
                <p *ngIf="contactDetailFormGroup.get('firstName')?.touched && contactDetailFormGroup.get('firstName')?.errors"
                    class="text-danger fs-14 mt-1 mb-0">
                    <span *ngIf="contactDetailFormGroup.get('firstName')?.hasError('required')">First name is
                        required</span>
                    <span *ngIf="contactDetailFormGroup.get('firstName')?.hasError('minlength')">First
                        name should be at least 2 characters. please enter a valid first name.</span>
                    <span *ngIf="contactDetailFormGroup.get('firstName')?.hasError('pattern')">please enter a valid
                        first
                        name.</span>
                </p>
            </div>
            <div class="col-lg-6 mb-4">
                <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Last name</label>
                <input type="text" class="form-control inputTyp1" formControlName="lastName"
                    placeholder="Enter last name">
                <p *ngIf="contactDetailFormGroup.get('lastName')?.touched && contactDetailFormGroup.get('lastName')?.errors"
                    class="text-danger fs-14 mt-1 mb-0">
                    <span *ngIf="contactDetailFormGroup.get('lastName')?.hasError('required')">Last name is
                        required</span>
                    <span *ngIf="contactDetailFormGroup.get('lastName')?.hasError('minlength')">Last
                        name should be at least 2 characters. please enter a valid last name.</span>
                    <span *ngIf="contactDetailFormGroup.get('lastName')?.hasError('pattern')">please enter a valid last
                        name.</span>
                </p>
            </div>
            <div class="col-lg-6 mb-4">
                <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Mobile</label>
                <input type="text" class="form-control inputTyp1" formControlName="phone" inputmode="numeric"
                    placeholder="Enter phone">
                <p *ngIf="contactDetailFormGroup.get('phone')?.touched && contactDetailFormGroup.get('phone')?.errors"
                    class="text-danger fs-14 mt-1 mb-0">
                    <span *ngIf="contactDetailFormGroup.get('phone')?.hasError('required')">Mobile is required</span>
                    <span
                        *ngIf="contactDetailFormGroup.get('phone')?.hasError('minlength') || contactDetailFormGroup.get('phone')?.hasError('pattern')">Please
                        provide a valid mobile number.</span>
                </p>
            </div>
            <div class="col-lg-6 mb-4">
                <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Email</label>
                <input type="email" class="form-control inputTyp1" formControlName="contactEmail"
                    placeholder="Enter email">
                <p *ngIf="contactDetailFormGroup.get('contactEmail')?.touched && contactDetailFormGroup.get('contactEmail')?.errors"
                    class="text-danger fs-14 mt-1 mb-0">
                    <span *ngIf="contactDetailFormGroup.get('contactEmail')?.hasError('required')">Email is
                        required</span>
                    <span *ngIf="contactDetailFormGroup?.get('contactEmail')?.hasError('pattern')">Please provide a
                        valid email
                        address.</span>
                </p>
            </div>
        </div>
    </form> -->

    <app-contact-form 
        *ngIf="!loaForm.get('contactEmail')?.disabled && f1['generateType'].value != 1 && !isLoaLoading" 
        [(contactDetailFormGroup)]="contactDetailFormGroup"
        [showContactList]="false"></app-contact-form>

    <p *ngIf="successMessage" class="text-success mb-0 fs-14">{{ successMessage }}</p>
    <p *ngIf="errorMessage" class="text-danger mb-0 fs-14">{{ errorMessage }}</p>
    <div class="d-grid d-md-flex justify-content-md-end gap-3 mt-2">
        <button [disabled]="isLoading" type="button" class="GA-registerClose btn-secondary" (click)="close()">
            Close
        </button>
        <button [disabled]="isLoading || isDisableForm"
            type="button" class="GA-resetLink btn-primary" (click)="saveContactInfo()">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isLoading ? '' : (f1['generateType'].value == 2 ? ( userService.isLOAAwaiting ? (selectedLoa.authorisedEmailId?.toLocaleLowerCase() == contactDetailFormGroup.get('contactEmail')?.value?.toLocaleLowerCase() ? 'Resend LoA' : 'Send LoA') : 'Send LoA') : 'Save details') }}
        </button>
    </div>
</div>